import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  onClick,
  href
}: ButtonProps) {
  const handleClick = () => {
    if (href) {
      // Get current URL parameters
      const currentParams = new URLSearchParams(window.location.search);
      // Create URL with current parameters
      const nextUrl = `${href}${currentParams.toString() ? '?' + currentParams.toString() : ''}`;
      window.location.href = nextUrl;
    }
    onClick?.();
  };
  return <button onClick={handleClick} className="px-12 py-4 bg-green-600 hover:bg-green-700 text-white font-medium text-xl rounded-md shadow-md transition-colors duration-200 uppercase tracking-wide" data-id="element-9">
      {children}
    </button>;
}